module.exports = __webpack_public_path__ + "img/area-chart.1cb52649.svg";